import AteliersTab from "@features/creation/ateliers/components/AteliersTab";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Building2 } from "lucide-react";

export const Route = createFileRoute("/_app/creation/ateliers/")({
  loader: requirePermission(PERMISSIONS.CREATION.ATELIERS.VIEW),
  staticData: {
    title: "Ateliers",
    icon: Building2,
    tab_icon: Building2,
    permission: PERMISSIONS.CREATION.ATELIERS.VIEW,
    module: "creation",
    section: "Creation",
    order: 24,
    description: "Gestion des ateliers",
    showInNav: true,
    showInTab: true,
    showInBreadcrumb: true,
  },
  component: AteliersTab,
});
